export default __webpack_public_path__ + "static/media/avatar.5a18a036.jpeg";